/**
 * WordPress site / REST API configuration.
 *
 * Client (Vite): uses VITE_WORDPRESS_BASE_URL from .env / .env.local
 * Server uploads (ots): use WP_BASE_URL, WP_USER, WP_APP_PASSWORD — never VITE_*
 */

const DEFAULT_WORDPRESS_BASE_URL = 'https://transfusionontario.org';

export const WORDPRESS_BASE_URL = (
  import.meta.env.VITE_WORDPRESS_BASE_URL || DEFAULT_WORDPRESS_BASE_URL
).replace(/\/$/, '');

export const WORDPRESS_API_BASE = `${WORDPRESS_BASE_URL}/wp-json/wp/v2`;

// WordPress Admin URLs
export const WP_ADMIN_BASE = `${WORDPRESS_BASE_URL}/wp-admin`;
export const WP_ADMIN_TOOLKITS_NEW = `${WP_ADMIN_BASE}/post-new.php?post_type=toolkit`;

// The Events Calendar REST API
export const WORDPRESS_TEC_EVENTS_API = `${WORDPRESS_BASE_URL}/wp-json/tribe/events/v1/events`;

// API Endpoints
export const API_ENDPOINTS = {
  posts: `${WORDPRESS_API_BASE}/posts`,
  categories: `${WORDPRESS_API_BASE}/categories`,
  tags: `${WORDPRESS_API_BASE}/tags`,
  media: `${WORDPRESS_API_BASE}/media`,
  search: `${WORDPRESS_API_BASE}/search`,
} as const;
